export enum Sections {
  apteki = 'apteki',
  veterinariy = 'veterinariy',
  eCertificate = 'elektronnii-sertifikat'
}
